import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CrudDataService } from '../../shared/services/crud-data.service';
import { SecurityService } from '../../shared/services/security.service';
import { Configuration } from '../../app.configuration.service';
import { PedidoIntervencao } from '../../model/pedidoIntervencao/pedidoIntervencao';
import { FileInfo } from 'src/app/shared/model/generic/fileInfo';
import { decode } from 'base64-arraybuffer';
import { catchError, map, Observable } from 'rxjs';
import { SearchFilterBase } from 'src/app/shared/model/search/searchFilterBase';

@Injectable()
export class PedidoIntervencaoDataService extends CrudDataService<PedidoIntervencao> {

  constructor(protected http: HttpClient, protected configuration: Configuration, protected securityService: SecurityService) {
    super(http, configuration, securityService);
    this.controllerName = 'v1/PedidoIntervencao';
  }

  public getAcompanhamento = (pedidoIntervencaoId: number): Observable<any> => {
    const fullUrl = `${this.configuration.apiServerUrl}/api/${this.controllerName}/GetAcompanhamento/${pedidoIntervencaoId}`;
    return this.http
      .get(fullUrl, this.options)
      .pipe(
        map(response => response)
        , catchError(this.handleError)
      );
  }

  public getHistoricoEstados = (pedidoIntervencaoId: number): Observable<any> => {
    const fullUrl = `${this.configuration.apiServerUrl}/api/${this.controllerName}/GetHistoricoEstados/${pedidoIntervencaoId}`;
    return this.http.get(fullUrl, this.options);
  }

  public SearchDiasImobilizacao = (filter: SearchFilterBase): Observable<FileInfo> => {
    const toSend = JSON.stringify(filter);
    return this.httpPostGetFile('SearchDiasImobilizacao', toSend);
  }

  public SearchAnalise = (filter: SearchFilterBase): Observable<FileInfo> => {
    const toSend =JSON.stringify(filter);
    return this.httpPostGetFile('SearchAnalise', toSend);
  }


  public cancelarPedido = (pedidoIntervencaoId: number, observacoes: string): Observable<boolean> => {
    const toSave = JSON.stringify({ pedidoIntervencaoId, observacoes });
    return this.httpPost('CancelarPedido', toSave);
  }

  public fecharPedido = (pedidoIntervencaoId: number, dataEntradaOficina: Date, dataEntrega: Date, observacoes: string): Observable<boolean> => {
    const toSave = JSON.stringify({ pedidoIntervencaoId, dataEntradaOficina, dataEntrega, observacoes });
    return this.httpPost('FecharPedido', toSave);
  }

  public imprimir = (pedidoIntervencaoId: number): Observable<FileInfo> => {
    const fullUrl = `${this.configuration.apiServerUrl}/api/${this.controllerName}/GetPdf/${pedidoIntervencaoId}`;
    return this.http
      .get(fullUrl, this.options)
      .pipe(
        map(response => {
          const myFile = new FileInfo();
          if ((response as any).content != null) {
            myFile.filename = (response as any).filename;
            myFile.content = new Blob([decode((response as any).content)], { type: (response as any).contentType });
          }
          return myFile;
        })
        , catchError(this.handleError));
  }
}
